
export const BACKEND_URL = process.env.NODE_ENV !== 'development' ? "https://joyyadb.com/api": "http://localhost:4000";
